import React from 'react';
import TablaDolarBcv from './tablaDolarBcv';

export const DolarBcv = (props) => {
    return (
        <div className='container-fluid rounded p-0 m-0'>
        <div className='container-fluid w-100 h-100 p-0 m-0'>
              <TablaDolarBcv />
           </div>
        </div>

    );
}


// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/valordolarbcv.js